module.exports = __webpack_public_path__ + "img/icon_weather_413.79263453.svg";